import { render, staticRenderFns } from "./LinkedIdentitiesPanel.vue?vue&type=template&id=7913591b&scoped=true&"
import script from "./LinkedIdentitiesPanel.vue?vue&type=script&lang=ts&"
export * from "./LinkedIdentitiesPanel.vue?vue&type=script&lang=ts&"
import style0 from "./LinkedIdentitiesPanel.vue?vue&type=style&index=0&id=7913591b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7913591b",
  null
  
)

export default component.exports